'use strict';

angular.module('listingSeenController', [])

.controller('ListingSeenController', ['appInfo', '$scope', '$rootScope', '$log', '$location', '$window','BuyerService', 'CommonService',
    function (appInfo, $scope, $rootScope, $log, $location, $window, BuyerService, CommonService) {    
    
    var currentUser = $rootScope.currentUser;

    $scope.page = 'listingSeen';
    $scope.listingSeenProperties = [{}];
    $scope.watchlist = [];
    $scope.propertyDetail = {};
    $scope.openHomeDetail = {};
    $scope.propertyRefs = [];
    $scope.propertyMicrositeURL = {};

    $scope.currentPageSection = 'list';  //can be propertyDetail, enquiryForm depending upon what section is displayed
    $scope.previousPageSection = 'list';
    $scope.showWeeklyRentReturn = false;
    $scope.weeklyRentReturn = '';    

    var loadListingSeen = function() {
        var upstreamCall = true;
        if(!$rootScope.loading) {
            $rootScope.loading = true;
            upstreamCall = false;
        }

        BuyerService.getListingSeen()
        .then(function(data){
            $scope.listingSeenProperties = data;
            return BuyerService.getWatchlist();
        })
        .then(function(data){
            $scope.watchlist = data;
            angular.forEach($scope.listingSeenProperties, function(listing){
                var property = listing.property;
                $scope.propertyRefs.push(listing.property.propertyRef);
                var index = CommonService.indexByField($scope.watchlist, 'propertyId', property.propertyId);
                if(index > -1) {
                    property.watched = true;
                    property.watchlistId = $scope.watchlist[index].id;
                } else {
                    property.watched = false;
                    property.watchlistId = 0;
                }
            });
            return BuyerService.getPropertyMicrositeURL($scope.propertyRefs);  
        })
        .then(function(data) {
            $scope.propertyMicrositeURL = data;
        })
        .catch(function(err) {
            console.log(err);
        })
        .finally(function(data) {
            // loadPreferences();
            if (!upstreamCall) {
                $rootScope.loading = false;
            }
            
        });

        //load preferences from db
      
    }

    var init = function() {
        
        $scope.currentPageSection = 'list';
        $scope.previousPageSection = 'list';
        $scope.propertyDetail = {};

        loadListingSeen();
    }

    $scope.addToWatchlist = function(property) {
        $rootScope.loading = true;
        BuyerService.addToWatchlist(property.propertyId)
        .then(function(data){
            property.watched = true;
            property.watchlistId = data;
            // loadProperties();
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(err){
            $rootScope.loading = false;
        })
    }

    $scope.removeFromWatchlist = function(property) {
        $rootScope.loading = true;
        BuyerService.removeFromWatchlist(property.watchlistId)
        .then(function(data){
            property.watched = false;
            property.watchlistId = 0;
            // loadProperties();
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(err){
            $rootScope.loading = false;
        })
    }

    $scope.displayPageSection =  function(section) {
      return (section == $scope.currentPageSection);
    }

    $scope.showPageSection = function(property, section) {
        $scope.page = section;
        $scope.previousPageSection = $scope.currentPageSection;
        $scope.currentPageSection = section;
        $scope.propertyDetail = property;
        $scope.openHomeDetail = {};
        if (property.openHome[0].length) {
            $scope.openHomeDetail = property.openHome[0][0];    
        }
        
    }

    $scope.hidePageSection = function() {
        var previousPage = $scope.currentPageSection;
        $scope.page = 'listingSeen';
        $scope.currentPageSection = $scope.previousPageSection;
        $scope.previousPageSection = previousPage;
        $scope.propertyDetail = {};
        $scope.openHomeDetail = {};
    }

    $scope.displayWeeklyRentReturn = function(property) {
        var propertyAddress = property.streetUnit + ' '  + property.streetRef + ' ' + property.streetName + ' ' + property.streetType; 
        var noteText = "Buyer clicked approximate rent return for the property: " + propertyAddress;
        BuyerService.addNote(noteText)
        .then(function(data){
            $scope.showWeeklyRentReturn = true;
            $scope.weeklyRentReturn = property.weeklyRentReturn;    
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(data){

        });
    }

    $scope.getPropertyURL = function(propertyRef) {
        var propertyURL = 'http://www.wiseberry.com.au/property/' + propertyRef;
        if($scope.propertyMicrositeURL[propertyRef]) {
            propertyURL = $scope.propertyMicrositeURL[propertyRef];
        }
        return propertyURL;
    }

    init();

}]);